import { useState, type FormEvent } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AuthField, AuthShell, FormError } from "@/components/AuthForm";
import { api, formatApiError } from "@/lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const [form, setForm] = useState({ password: "", confirm_password: "" });
  const [error, setError] = useState("");
  const [state, setState] = useState<"idle" | "loading" | "done">("idle");

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 8) return setError("La contraseña debe tener al menos 8 caracteres");
    if (form.password !== form.confirm_password) return setError("Las contraseñas no coinciden");
    setState("loading");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") ?? "", ...form });
      setState("done");
    } catch (err) { setError(formatApiError(err)); setState("idle"); }
  };

  return (
    <AuthShell title="Nueva contraseña" subtitle="Escribe la contraseña que usarás para entrar.">
      {state === "done" ? (
        <div data-testid="reset-done">
          <p className="text-sm text-slate-600">Listo, ya cambiamos tu contraseña. Cerramos tus sesiones abiertas por seguridad.</p>
          <Link to="/login" className="mt-5 inline-flex h-11 w-full items-center justify-center rounded-md bg-[#1B2A4A] font-semibold text-white" data-testid="reset-go-login">Iniciar sesión</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
          <AuthField id="reset-password" label="Nueva contraseña" type="password" value={form.password} onChange={(v) => setForm((f) => ({ ...f, password: v }))} autoComplete="new-password" />
          <AuthField id="reset-confirm" label="Repite la nueva" type="password" value={form.confirm_password} onChange={(v) => setForm((f) => ({ ...f, confirm_password: v }))} autoComplete="new-password" />
          <FormError message={error} testId="reset-error" />
          <Button type="submit" disabled={state === "loading"} className="h-11 w-full bg-[#1B2A4A] text-white hover:bg-[#2A3D63]" data-testid="reset-submit">
            {state === "loading" ? <Loader2 className="h-4 w-4 animate-spin" /> : "Guardar contraseña"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
